import {Howl} from "howler";
import * as PIXI from "pixi.js";
import data from "./configs/data";
import {CustomSpineAnimation} from "./CustomSpineAnimation";
import {Utils} from "./Utils";

export class GoldenChips extends PIXI.Container {

    private readonly GOLDEN_CHIPS_ANIMATION_CONFIG = {
        NAME: "goldenChips",
        STATES: {
            FADE_IN: "fadeIn",
            FADE_OUT: "fadeOut",
        },
        SLOT_CONTAINERS: {
            CONTAINER: "container",
        },
    };
    private readonly WIN_AMOUNT_STYLE = {
        fontSize: 37,
        fontWeight: "bolder",
        fontFamily: "RobotoRegular",
        fill: "#000",
    };
    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);
    private readonly COUNT_UP_TIME = 1500;

    private goldenChipsAnimation: CustomSpineAnimation;
    private winAmountText: PIXI.Text;
    private sound: Howl;

    constructor() {
        super();
        this.createAndAddGoldenChipsAnimation();
        this.createAndAddWinAmountText();
        this.sound = new Howl({
            src: [data.audios.goldenChipWin],
            volume: 0.9,
        });
    }

    public showChips(prize: number): void {
        this.winAmountText.text = "";
        this.goldenChipsAnimation.play(this.GOLDEN_CHIPS_ANIMATION_CONFIG.STATES.FADE_IN);
        this.sound.play();
        Utils.requestTimeout(1000);
        this.playCountUpAnimation(prize);
    }

    private hideChips(): void {
        this.goldenChipsAnimation.play(this.GOLDEN_CHIPS_ANIMATION_CONFIG.STATES.FADE_OUT);
    }

    private playCountUpAnimation(prize: number): void {
        let currentCountUpValue = 0;
        const numberQuantum = prize / (this.COUNT_UP_TIME / PIXI.ticker.shared.elapsedMS);
        const countUpFunction = async (delta) => {
            if (currentCountUpValue < prize) {
                this.winAmountText.text = Utils.formatAmount(currentCountUpValue);
                currentCountUpValue += numberQuantum * delta;
            } else {
                PIXI.ticker.shared.remove(countUpFunction);
                this.winAmountText.text = Utils.formatAmount(prize);
                await Utils.requestTimeout(1000);
                this.hideChips();
            }
        };
        PIXI.ticker.shared.add(countUpFunction);
    }

    private createAndAddGoldenChipsAnimation(): void {
        this.goldenChipsAnimation = new CustomSpineAnimation(this.GOLDEN_CHIPS_ANIMATION_CONFIG.NAME);
        this.addChild(this.goldenChipsAnimation);
    }

    private createAndAddWinAmountText(): void {
        this.winAmountText = new PIXI.Text("", this.WIN_AMOUNT_STYLE);
        this.winAmountText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.winAmountText.scale.y = -1;
        this.goldenChipsAnimation.getSlotContainer(this.GOLDEN_CHIPS_ANIMATION_CONFIG.SLOT_CONTAINERS.CONTAINER,
            true).addChild(this.winAmountText);
    }
}



// WEBPACK FOOTER //
// ./src/app/GoldenChips.ts